<template>
  <div>
    <component
      :is="field.widget"
      v-for="field in fields"
      :key="field.name"
      :entity_type="type"
      :entity="entity"
      :field="field"
      :scope="scope"
      v-model="entity[field.name]"
    />
    <SubmitButton
      :id="id"
      :type="type"
      :submit-label="submitLabel"
      :persistence="persistence"
      :mode="mode"
      :scope="scope"
      :popup="popup"
      :continue="true"
      v-if="(id && persistence !== 'dependent') || forceContinue"
    />
    <SubmitButton
      :id="id"
      :type="type"
      :submit-label="submitLabel"
      :persistence="persistence"
      :mode="mode"
      :scope="scope"
      :popup="popup"
      :continue="false"
    />
  </div>
</template>

<script>
import entities from "../api/entities";
import StringField from "./fields/StringField";
import TextField from "./fields/TextField";
import DateField from "./fields/DateField";
import DateTimeField from "./fields/DateTimeField";
import CheckboxField from "./fields/CheckboxField";
import SwitchField from "./fields/SwitchField";
import ChoicesField from "./fields/ChoicesField";
import FileField from "./fields/FileField";
import ImageField from "./fields/ImageField";
import ImagesField from "./fields/ImagesField";
import ListField from "./fields/ListField";
import ColorField from "./fields/ColorField";
import SubmitButton from "./SubmitButton";
import TiptapField from "./fields/TiptapField";
import HiddenField from "./fields/HiddenField";
import { logState } from "../classes/logging";

const widgets = {
  int: "StringField",
  string: "StringField",
  date: "DateField",
  datetime: "DateTimeField",
  hidden: "HiddenField",
  text: "TextField",
  tiptap: "TiptapField",
  boolean: "CheckboxField",
  checkbox: "CheckboxField",
  switch: "SwitchField",
  file: "FileField",
  image: "ImageField",
  images: "ImagesField",
  choices: "ChoicesField",
  list: "ListField",
  color: "ColorField"
};

export default {
  name: "FormView",
  props: [
    "type",
    "id",
    "submitLabel",
    "persistence",
    "mode",
    "_entity",
    "scope",
    "popup"
  ],
  components: {
    StringField,
    TextField,
    TiptapField,
    DateField,
    DateTimeField,
    HiddenField,
    CheckboxField,
    SwitchField,
    ChoicesField,
    FileField,
    ImageField,
    ImagesField,
    ListField,
    ColorField,
    SubmitButton
  },
  data() {
    return {
      forceContinue: null,
      entity: {},
      fields: [],
      errors: {}
    };
  },
  async mounted() {
    window.o = window.o || [];
    const o = () => {
      logState(
        "FormView.state",
        { color: "orange" },
        "entity:",
        this.entity,
        "_entity:",
        this._entity
      );
    };
    window.o.push(o);

    logState(
      "FormView.mounted",
      { color: "orange" },
      "id:",
      this.id,
      "_entity:",
      this._entity,
      "scope:",
      this.scope
    );
    if (this.id) {
      const result = await entities.get(
        this.token,
        this.type,
        this.id,
        this.scope
      );
      this.onEntityReceived(result);
    } else {
      const result = await entities.fields(this.token, this.type, this.scope);
      if (result.save_and_continue !== undefined) this.forceContinue = true; // to bad...
      this.onEntityCreate(result);

      if (this._entity) {
        if (this._entity.data) this.entity = this._entity.data;
        else this.entity = this._entity;
      }
      if (result.entity) {
        for (let [k, v] of Object.entries(result.entity)) this.entity[k] = v;
      }
      logState(
        "FormView.mounted after onEntityCreate",
        { color: "orange" },
        "entity:",
        this.entity,
        "_entity:",
        this._entity
      );
    }
  },
  methods: {
    // onInput(value) {
    //   console.log("ON INPUT", value, this.entity);
    // },
    onEntityReceived(result) {
      console.log("FormView.onEntityReceived", result);
      this.entity = result.entity;
      this.fields = result.fields;
      for (const field of this.fields) {
        if (field.widget && field.widget.name)
          field.widget = widgets[field.widget.name];
        else if (field.widget) field.widget = widgets[field.widget];
        else field.widget = widgets[field.type];
        if (field.widget === undefined)
          console.warn("Widget is undefined for field:", field);
        // field.widget = "StringField";
      }
      console.log("FIELDS", this.fields);
    },
    onEntityCreate(result) {
      this.fields = result.fields;

      for (const field of this.fields) {
        this.entity[field.name] = null;
        if (field.type === "date")
          this.entity[field.name] = new Date().toISOString().substring(0, 10);
        if (field.type === "boolean") this.entity[field.name] = false;
        if (field.type === "int") this.entity[field.name] = 0;
        if (field.type === "string" || field.type === "text")
          this.entity[field.name] = "";
        if (field.type === "choices" && field.multiple === true)
          this.entity[field.name] = [];

        if (field.widget && field.widget.name)
          field.widget = widgets[field.widget.name];
        else if (field.widget) field.widget = widgets[field.widget];
        else field.widget = widgets[field.type];
        if (field.widget === undefined)
          console.warn("Widget is undefined for field:", field);
      }
      console.warn("FormView.onEntityCreate", "this.fields", this.fields);
    }
  },
  watch: {
    _entity: {
      async handler() {
        console.log("_entity changed", this._entity);
        if (this._entity) {
          if (this._entity.data) this.entity = this._entity.data;
          else this.entity = this._entity;
        }
      }
    },
    id: {
      async handler() {
        const result = await entities.get(this.token, this.type, this.id);
        this.onEntityReceived(result);
      }
    }
  }
};
</script>

<style lang="scss">
.editor-content {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid rgba(200, 200, 255, 0.4);
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;
      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: 0;
      width: 4px;
      z-index: 20;
      background-color: #adf;
      pointer-events: none;
    }
  }

  .tableWrapper {
    margin: 1em 0;
    overflow-x: auto;
  }
}

.resize-cursor {
  cursor: ew-resize;
  cursor: col-resize;
}
</style>
